// Product-language translations for a project collaboration workspace.
// Keys are visible English UI phrases; values intentionally follow common
// Chinese SaaS/project-management terminology instead of literal wording.
export const zhCN = {
    'Home': '首页',
    'Projects': '项目',
    'Project': '项目',
    'Tasks': '任务',
    'Task': '任务',
    'Time Sheet': '工时表',
    'User Timesheet': '成员工时',
    'Project Timesheet': '项目工时',
    'Workload Timesheet': '工作量统计',
    'Tracker Timesheet': '计时记录',
    'Reports': '报表',
    'Milestone Report': '里程碑报表',
    'Search': '搜索',
    'Open Advance Filter': '打开高级筛选',
    'Company': '企业',
    'My Profile': '个人资料',
    'Settings': '设置',
    'Logout': '退出登录',
    'Login': '登录',
    'Login to your Account': '登录您的账户',
    'See what is going on with your business': '查看并推进您的团队工作',
    'Loading': '加载中',
    'Loading...': '加载中…',
    'Email': '邮箱',
    'Email ID': '邮箱',
    'Password': '密码',
    'Remember Me': '记住我',
    'Forgot Password?': '忘记密码？',
    'Welcome Back!': '欢迎回来！',
    'Sign in to continue to Xcreate': '登录后继续使用 Xcreate',
    'Work on big ideas, without the busywork.': '专注重要工作，让协作更高效。',
    'Resend Email': '重新发送邮件',
    'Back to Login?': '返回登录？',
    'Queue List': '待办队列',
    '+ Add to Queue': '+ 加入队列',
    'Add to Queue': '加入队列',
    'Add to Queue List': '加入待办队列',
    'Remove from Queue List': '移出待办队列',
    'No queue list found': '队列中暂无任务',
    'My Work': '我的工作',
    'To Do': '待处理',
    'In Progress': '进行中',
    'In Review': '审核中',
    'Backlog': '待规划',
    'On Hold': '已暂停',
    'Ready For Production': '待发布',
    'Code Review': '代码评审',
    'Done': '已完成',
    'Ready for Acceptance': '待验收',
    'Complete': '已完成',
    'Completed': '已完成',
    'Open': '进行中',
    'Closed': '已关闭',
    'Today': '今天',
    'Overdue': '已逾期',
    'Next': '下一步',
    'Unscheduled': '未安排',
    'Calendar': '日历',
    'Hide': '收起',
    'No today task assigned to you.': '今天没有分配给你的任务。',
    'No overdue task assigned to you.': '没有分配给你的逾期任务。',
    'No next task assigned to you.': '近期没有分配给你的任务。',
    'No unscheduled task assigned to you.': '没有分配给你的未排期任务。',
    'No task found': '暂无任务',
    'No data found': '暂无数据',
    'Notification Request': '通知权限',
    'Do you want to enable browser notifications?': '是否允许接收浏览器通知？',
    'Yes': '允许',
    'No': '暂不',
    'Notifications': '通知',
    'Notification': '通知',
    'Mentions': '提及我的',
    '@Mentions': '@提及',
    'Mark all as read': '全部标为已读',
    'Chat': '沟通',
    'Tours': '新手引导',
    'Take a Tour': '新手引导',
    'Mark all as Complete': '全部标记为已完成',
    'Project Tour': '工作区快速入门',
    'Dashboard': '首页工作台',
    'Time Tracker': '工时计时',
    'Task Tour': '任务管理入门',
    'Create Project Tour': '创建项目',
    'Project View Tour': '项目视图',
    'Project Left Side Tour': '项目导航与组织',
    'Learn the main workspace navigation, project collaboration, notifications, and team chat.': '了解工作区导航、项目协作、消息通知与团队沟通。',
    'Review your assigned work, overdue tasks, and personal work queue from the dashboard.': '在首页查看分配给我的工作、逾期任务和个人待办队列。',
    'Track working time accurately and connect time entries with projects and tasks.': '准确记录工作时长，并将工时关联到对应的项目和任务。',
    'Create tasks and manage status, assignees, priorities, due dates, subtasks, and attachments.': '创建任务，并管理状态、负责人、优先级、截止日期、子任务与附件。',
    'Create a project and configure its name, team, visibility, workflow, and default views.': '创建项目，并设置项目名称、协作成员、可见范围、工作流和默认视图。',
    'Switch between list, board, table, calendar, timeline, Gantt, and other project views.': '根据协作场景切换列表、看板、表格、日历、时间线和甘特图等项目视图。',
    'Use the project sidebar to organize folders, sprints, archived work, and project settings.': '使用项目侧边栏管理文件夹、迭代、归档内容和项目设置。',
    'List': '列表',
    'Board': '看板',
    'Table': '表格',
    'Calendar View': '日历视图',
    'Project List': '项目列表',
    'Create Project': '新建项目',
    'New Project': '新建项目',
    '+ New Task': '+ 新建任务',
    'New Task': '新建任务',
    'Create Task': '新建任务',
    'Suggest Tasks': '智能推荐任务',
    'Write with AI': 'AI 辅助编写',
    'Group by : Status': '分组方式：状态',
    'Group by :': '分组方式：',
    'Group By': '分组方式',
    'Status': '状态',
    'Subtask : Collapsed': '子任务：收起',
    'Subtask :': '子任务：',
    'Collapsed': '收起',
    'Expanded': '展开',
    'Show Archived': '显示已归档',
    'Share with :': '可见范围：',
    'Everyone': '所有成员',
    'Private': '仅指定成员',
    'Public': '公开',
    'Assignee': '负责人',
    'Reporter': '报告人',
    'Due Date': '截止日期',
    'Start Date': '开始日期',
    'Priority': '优先级',
    'Key': '编号',
    'Created Date': '创建时间',
    'Created By': '创建人',
    'Updated Date': '更新时间',
    'Task Name': '任务名称',
    'Task Type': '任务类型',
    'Description': '任务描述',
    'description': '任务描述',
    'Add description': '添加任务描述',
    'Add Description': '添加任务描述',
    'Task Detail': '任务详情',
    'Activity Log': '操作记录',
    'Scroll to Bottom': '回到底部',
    'Activity': '动态',
    'Comments': '评论',
    'Comment': '评论',
    'Files & Links': '文件与链接',
    'Audio Files': '音频文件',
    'Checklist': '检查清单',
    'Suggest Checklists': 'AI 生成检查清单',
    'Add Checklist': '添加检查项',
    'Add a Checklist': '添加检查项',
    'a Checklist': '检查项',
    'Subtasks': '子任务',
    'Subtask': '子任务',
    'Add Subtask': '添加子任务',
    '+ Add Subtask': '+ 添加子任务',
    'Suggest Subtasks': 'AI 生成子任务',
    'No subtasks': '暂无子任务',
    'Attachments': '附件',
    'Attachments(': '附件（',
    'Drop files here to attach or': '将文件拖到此处，或',
    'browse': '选择文件',
    'Watchers': '关注人',
    'watchers': '关注人',
    'List of watchers': '关注人列表',
    'Add Comment': '添加评论',
    'Post Comment': '发表评论',
    'Reply': '回复',
    'Edit': '编辑',
    'Rename': '重命名',
    'Delete': '删除',
    'Archive': '归档',
    'Archive Project': '归档项目',
    'Color & Avatar': '颜色与图标',
    'Close Project': '关闭项目',
    'Delete Project': '删除项目',
    'Restore': '恢复',
    'Duplicate': '创建副本',
    'Move': '移动',
    'Save': '保存',
    'Cancel': '取消',
    'Confirm': '确认',
    'Close': '关闭',
    'Apply': '应用',
    'Reset': '重置',
    'Clear': '清除',
    'Update': '更新',
    'Create': '创建',
    'Add': '添加',
    'Remove': '移除',
    'Submit': '提交',
    'Continue': '继续',
    'Back': '返回',
    'Next Step': '下一步',
    'Previous': '上一步',
    'Name': '名称',
    'Type': '类型',
    'Owner': '所有者',
    'Admin': '管理员',
    'Member': '成员',
    'Guest': '访客',
    'Members': '成员',
    'Teams': '团队',
    'Roles': '角色',
    'Permissions': '权限',
    'Project Permissions': '项目权限',
    'Security & Permissions': '安全与权限',
    'My Settings': '个人设置',
    'Company Settings': '企业设置',
    'General Settings': '常规设置',
    'Notifications Settings': '通知设置',
    'Custom Fields': '自定义字段',
    'Templates': '模板',
    'Apps': '应用',
    'Integrations': '集成',
    'Billing': '订阅与账单',
    'Profile': '资料',
    'Designation': '职位',
    'Phone Number': '手机号',
    'Country': '国家或地区',
    'State': '省/州',
    'City': '城市',
    'High': '高',
    'Medium': '中',
    'Low': '低',
    'Fixed Price': '固定总价',
    'Hourly Price': '按小时计费',
    'In House': '内部项目',
    'Milestone': '里程碑',
    'Time Log': '工时记录',
    'Log Time': '登记工时',
    'Estimated Time': '预估工时',
    'Hours': '小时',
    'Minutes': '分钟',
    'All': '全部',
    'Active': '进行中',
    'Archived': '已归档',
    'Filter': '筛选',
    'Sort': '排序',
    'Export': '导出',
    'Import': '导入',
    'Upload': '上传',
    'Download': '下载',
    'Select': '请选择',
    'Select All': '全选',
    'No results found': '未找到匹配结果',
    'Something went wrong.': '操作失败，请稍后重试。',
    'Task created successfully': '任务创建成功',
    'Project created successfully': '项目创建成功',
    'Settings updated successfully': '设置更新成功',
    'Upgrade Your Plan': '升级套餐',
    'Upgrade To Unlimited To Unlock List View': '升级套餐以解锁列表视图',
    'That feature isn’t available on your current plan': '当前套餐暂不支持此功能',
    'No record found': '暂无记录',
    'No records found': '暂无记录',
    'No Data Found': '暂无数据',
    'No date found': '暂无日期',
    'No Due Date': '未设置截止日期',
    'No Start Date': '未设置开始日期',
    'No Item Found.': '暂无内容',
    'Back to Projects': '返回项目',
    'Clear all': '全部清除',
    'My Filters': '我的筛选',
    'Filter by': '筛选条件',
    'Filtering Field': '筛选字段',
    'Filter Operator': '筛选规则',
    'Save this Filter': '保存此筛选',
    'Save this Filters': '保存此筛选',
    'Save Filters': '保存筛选',
    'Update filter': '更新筛选',
    'Show Results': '查看结果',
    'Sort by:': '排序方式：',
    'Project Name': '项目名称',
    'Project Status': '项目状态',
    'Task Status': '任务状态',
    'Project Description': '项目说明',
    'Sprint': '迭代',
    'Folder': '文件夹',
    'Category': '分类',
    'Unassigned': '未分配',
    'Select Status': '选择状态',
    'Select Task Type': '选择任务类型',
    'Select Options': '选择选项',
    'Select Assignee': '选择负责人',
    'Select Reporter': '选择报告人',
    'Select Priorities': '选择优先级',
    'Select Tags': '选择标签',
    'Users': '成员',
    'Leader': '负责人',
    'Invite': '邀请成员',
    'Details': '详情',
    'Files': '文件',
    'Links': '链接',
    'No link found': '暂无链接',
    'No Watchers': '暂无关注人',
    'No Assignee': '暂无负责人',
    'No assignee found': '请先设置负责人',
    'No due date found': '请先设置截止日期',
    'No self assignee found': '当前用户不是该任务负责人',
    'Access denied': '无权执行此操作',
    'Old Task Watchers': '原任务关注人',
    'New Task Watchers': '新任务关注人',
    'All Activity': '所有动态',
    'Participating and @mentions': '参与的任务和 @提及',
    'Ignore': '不接收通知',
    'Load More': '加载更多',
    'See All': '查看全部',
    'Tracked Time': '已跟踪工时',
    'Manual Time': '手动登记工时',
    'Logged': '已登记',
    'Estimated': '预估',
    'Total': '合计',
    'Time': '时间',
    'End Date': '结束日期',
    'Status Date': '状态日期',
    'Old Status': '原状态',
    'New Status': '新状态',
    'Source': '来源',
    'Currency': '币种',
    'Amount': '金额',
    'Regenerate': '重新生成',
    'Merge': '合并',
    'Pin view': '固定视图',
    'Convert to List': '转换为列表',
    'Convert to Subtask': '转换为子任务',
    'Convert to Task': '转换为任务',
    'Move Task': '移动任务',
    'Merge Task Into': '合并任务到',
    'Duplicate Task': '复制任务',
    'Location': '目标位置',
    'Browse Projects': '选择其他项目',
    'No Result Found': '未找到匹配结果',
    'Enter Task Name': '请输入任务名称',
    'Please Select Status': '请选择任务状态',
    'Please Select Task Type': '请选择任务类型',
    'Task moved sucessfully': '任务移动成功',
    'Task not moved': '任务移动失败',
    'Task duplicate sucessfully': '任务复制成功',
    'Task not duplicated': '任务复制失败',
    'Convert in to task sucessfully': '已转换为任务',
    'Copy Task Link': '复制任务链接',
    'Copy Task Key': '复制任务编号',
    'Archive task confirmation': '归档后任务将从当前视图隐藏，但可随时恢复；任务内容仍会保留并可被搜索。',
    'Delete task confirmation': '删除后将无法恢复。请输入任务名称，确认永久删除该任务。',
    'View': '视图',
    'Me': '我',
    'Create Custom Field': '新建自定义字段',
    '+ Add Custom Field': '+ 添加自定义字段',
    '+ Add New Custom Field': '+ 新建自定义字段',
    'Custom Field Manager': '自定义字段管理',
    'Custom Field': '自定义字段',
    '+ Custom Field': '+ 添加自定义字段',
    'Text': '单行文本',
    'Date': '日期',
    'Number': '数字',
    'Text Area (Long Text)': '多行文本',
    'Money': '金额',
    'Dropdown': '下拉选项',
    'Phone': '电话',
    'Multiple Select': '多选',
    'Person': '成员',
    'Checkbox': '复选框',
    'Label': '字段名称',
    'Action': '操作',
    'Field Name': '字段名称',
    'Date Created': '创建日期',
    'Created by': '创建人',
    'Created on': '创建时间',
    'Unknown date': '日期未知',
    'Type here': '输入评论',
    'No User Found': '未找到成员',
    'All Projects': '所有项目',
    'Unlimited': '不限量版',
    'Upgrade To': '升级至',
    'Create a short text area to add a quick point to the task.': '创建用于填写简短任务信息的单行文本字段。',
    'Create a Date field to add the due date, start date, or any specified date.': '创建用于记录开始日期、截止日期或其他业务日期的字段。',
    'Create this custom field to give specific numbers to the tasks.': '创建用于记录数量、评分或其他数值的任务字段。',
    'Create a field to enter the text for the task.': '创建用于填写较长任务说明或业务内容的多行文本字段。',
    'Create the money field to have a quick view of the transactions.': '创建用于记录预算、成本或其他金额信息的字段。',
    'Create this custom field to enter the email address.': '创建用于记录联系邮箱的字段。',
    'Create a dropdown menu field for the task.': '创建一个可从预设选项中选择的任务字段。',
    'Create a multi-select field for content attributes, channels, formats, or reusable business tags.': '创建可同时选择多个内容属性、渠道、形式或业务标签的字段。',
    'Create a people field linked to an active workspace member.': '创建与当前工作区成员关联的人员字段。',
    'Create a custom contact field to add the contact number.': '创建用于记录联系电话的字段。',
    'Create a field to add and view the checkbox in the task.': '创建用于标记是否完成或确认事项的复选字段。',
    'General': '基本设置',
    'Options': '选项设置',
    'Advanced': '高级设置',
    'Limits': '范围限制',
    'Field Label': '字段名称',
    'Enter Field Label': '请输入字段名称',
    'Placeholder': '占位提示',
    'Enter Placeholder': '请输入占位提示',
    'Field Description': '字段说明',
    'Enter Description': '请输入字段说明',
    '+ Add another item': '+ 添加选项',
    'Enter option': '请输入选项内容',
    'Predefined Options': '预设选项',
    'None': '不使用',
    'Gender': '性别',
    'Days': '星期',
    'Months': '月份',
    'Time Zone': '时区',
    'Choose a ready-made list of option (e.g., days, months, etc.)': '可直接使用星期、月份、国家或地区等系统预设选项。',
    'Selected By Default': '默认选中项',
    'Entry Limits': '输入范围',
    'Country Code': '国家或地区代码',
    '24 Hour': '24 小时制',
    'Search country': '搜索国家或地区',
    'no country found': '未找到国家或地区',
    'At least one field is required.': '请至少填写一个限制值。',
    'This field is required': '此项为必填项',
    'Limit the minimum or maximum amount of text allowed in this field': '设置该字段允许输入的最少或最多字符数。',
    'Enter Minimum Limit Type': '最少字符数',
    'Enter Maximum Limit Type': '最多字符数',
    'Enter Minimum Limit': '最小值',
    'Enter Maximum Limit': '最大值',
    'Enter Number': '请输入数字',
    'Maximum value should be greater than Minimum value.': '最大值必须大于最小值。',
    'Minimum value should not be greater than Maximum value': '最小值不能大于最大值。',
    'Maximum value should be greater than Minimum value': '最大值必须大于最小值。',
    'The entered value for Minimum Limit Type is not an allowed value.': '请输入有效的最小值。',
    'The entered value for Maximum Limit Type is not an allowed value.': '请输入有效的最大值。',
    'Limit the minimum or maximum value allowed for this field': '设置该字段允许填写的最小值或最大值。',
    'Search currency': '搜索币种',
    'no currency found': '未找到币种',
    'Note :': '注意：',
    "The change of below settings won't affect current field values if not empty": '以下设置变更不会覆盖已有的非空字段值。',
    'Turn it on to modify the country code.': '开启后允许修改国家或地区代码。',
    'Select the Default Country': '选择默认国家或地区',
    'Separator': '日期分隔符',
    'Date Formate': '日期格式',
    'Select a date format. D stands for day, M for month, and Y for year.': '选择日期显示格式；D 表示日，M 表示月，Y 表示年。',
    'Allow users to specify a time with date.': '允许成员在日期之外同时填写具体时间。',
    'Time Formate': '时间格式',
    'Select a time format': '选择时间显示格式。',
    'Past & Future': '可选日期范围',
    'Let users select dates in the past or future': '设置成员是否可以选择过去或未来的日期。',
    'Days of the week': '可选星期',
    'Unchecking a day will make it unavailable in the calendar': '取消勾选后，该星期将不能在日期选择器中使用。',
    'Past': '过去日期',
    'Future': '未来日期',
    'Lite Mode': '包含时间',
    'Sundays': '星期日',
    'Mondays': '星期一',
    'Tuesdays': '星期二',
    'Wednesdays': '星期三',
    'Thursdays': '星期四',
    'Fridays': '星期五',
    'Saturdays': '星期六',
    'To Unlock Custom Field': '解锁自定义字段',
    'Reset Permission': '重置权限',
    'Upload Image': '上传图片',
    'Save Template': '保存模板',
    'Template Name': '模板名称',
    'Title:': '标题：',
    'Description:': '说明：',
    'N/A': '暂无',
    'Language': '语言',
    'Simplified Chinese': '简体中文',
    'English': 'English'
};
